import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import { useSnackbar } from 'baseui/snackbar'
import {
  selectConfigCurrentContractActive,
  selectContractDetailsCurrentContractActive,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import {
  updateContractConfigData,
  updateContractDetailsData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import useRetrieveActiveContractIdAndType from '@/containers/SubscriptionFormPageNew/Layouts/useRetrieveActiveContractIdAndType'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import { selectCurrentContractActive } from '../../SubscriptionForm/SubscriptionFormSelectors'

const useSaveButtons = ({ setIsOpen = null }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { enqueue } = useSnackbar()
  const { id } = useRetrieveActiveContractIdAndType()
  const { businessCard } = useSelector(selectContractDetailsCurrentContractActive)

  const {
    isSaving,
    saveSuccess,
    message,
    feedbackSending,
    feedbackSent,
    feedbackError,
    completeStatusInfo = null,
  } = useSelector(selectConfigCurrentContractActive)
  const { transfertLog = null } = useSelector(selectCurrentContractActive)
  const { isEditable, resendAllowed, hasAlreadyVotedFeedback, errors = {} } = useFormStatus()
  const saveContract = (actionType = 'save') => {
    dispatch({
      type: subscriptionFormActionsV2.CONTRACT_SAVE,
      enqueue,
      action: actionType,
      handleError: setIsOpen,
    })
  }

  const sendFeedback = (feedback, comment = '') => {
    dispatch({
      type: subscriptionFormActionsV2.CONTRACT_SAVE_FEEDBACK,
      enqueue,
      feedback,
      comment,
    })
  }

  const contractUpdate = payload => {
    dispatch(updateContractDetailsData({ id, data: payload }))
  }

  const resetSaveSuccess = () => {
    dispatch(updateContractConfigData({ id, data: { saveSuccess: false } }))
  }

  return {
    saveContract,
    contractUpdate,
    sendFeedback,
    resetSaveSuccess,
    isSaving,
    saveSuccess,
    message,
    t,
    businessCard,
    isEditable,
    resendAllowed,
    hasAlreadyVotedFeedback,
    feedbackSending,
    feedbackSent,
    feedbackError,
    completeStatusInfo,
    errors,
    transfertLog,
    hasError: Object.keys(errors).length > 0,
    hasPodError: !!errors.address_pod_id_elec || !!errors.address_pod_id_gas || !!errors.address_pod_id_dual,
  }
}

export default useSaveButtons
